/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LogMessageOutputModel
 */
export interface LogMessageOutputModel {
    /**
     *
     * @type {string}
     * @memberof LogMessageOutputModel
     */
    deviceIdentity?: string;
    /**
     *
     * @type {Date}
     * @memberof LogMessageOutputModel
     */
    timestampUtc?: Date;
    /**
     *
     * @type {Date}
     * @memberof LogMessageOutputModel
     */
    loggedAt?: Date;
    /**
     *
     * @type {string}
     * @memberof LogMessageOutputModel
     */
    sender?: string;
    /**
     *
     * @type {string}
     * @memberof LogMessageOutputModel
     */
    messageId?: string;
    /**
     *
     * @type {string}
     * @memberof LogMessageOutputModel
     */
    type?: string;
    /**
     *
     * @type {string}
     * @memberof LogMessageOutputModel
     */
    payload?: string;
    /**
     *
     * @type {string}
     * @memberof LogMessageOutputModel
     */
    action?: string;
    /**
     *
     * @type {string}
     * @memberof LogMessageOutputModel
     */
    partitionKey?: string;
    /**
     *
     * @type {string}
     * @memberof LogMessageOutputModel
     */
    rowKey?: string;
    /**
     *
     * @type {Date}
     * @memberof LogMessageOutputModel
     */
    timestamp?: Date;
    /**
     *
     * @type {object}
     * @memberof LogMessageOutputModel
     */
    eTag?: object;
}

/**
 * Check if a given object implements the LogMessageOutputModel interface.
 */
export function instanceOfLogMessageOutputModel(
    value: object,
): value is LogMessageOutputModel {
    return true;
}

export function LogMessageOutputModelFromJSON(
    json: any,
): LogMessageOutputModel {
    return LogMessageOutputModelFromJSONTyped(json, false);
}

export function LogMessageOutputModelFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): LogMessageOutputModel {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        timestampUtc:
            json["timestampUtc"] == null
                ? undefined
                : new Date(json["timestampUtc"]),
        loggedAt:
            json["loggedAt"] == null ? undefined : new Date(json["loggedAt"]),
        sender: json["sender"] == null ? undefined : json["sender"],
        messageId: json["messageId"] == null ? undefined : json["messageId"],
        type: json["type"] == null ? undefined : json["type"],
        payload: json["payload"] == null ? undefined : json["payload"],
        action: json["action"] == null ? undefined : json["action"],
        partitionKey:
            json["partitionKey"] == null ? undefined : json["partitionKey"],
        rowKey: json["rowKey"] == null ? undefined : json["rowKey"],
        timestamp:
            json["timestamp"] == null ? undefined : new Date(json["timestamp"]),
        eTag: json["eTag"] == null ? undefined : json["eTag"],
    };
}

export function LogMessageOutputModelToJSON(
    value?: LogMessageOutputModel | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        timestampUtc:
            value["timestampUtc"] == null
                ? undefined
                : value["timestampUtc"].toISOString(),
        loggedAt:
            value["loggedAt"] == null
                ? undefined
                : value["loggedAt"].toISOString(),
        sender: value["sender"],
        messageId: value["messageId"],
        type: value["type"],
        payload: value["payload"],
        action: value["action"],
        partitionKey: value["partitionKey"],
        rowKey: value["rowKey"],
        timestamp:
            value["timestamp"] == null
                ? undefined
                : value["timestamp"].toISOString(),
        eTag: value["eTag"],
    };
}
